// Admin mail mutation: retry of a failed/bounced letter.
//
// Invalidation follows the shared admin pattern: invalidate the admin root,
// then refetch active queries so the open page reflects the status flip
// (failed → pending) at once.
import { useMutation } from '@tanstack/react-query';

import { queryClient } from '../../../shared/query/queryClient.js';

import { ADMIN_QUERY_ROOT, retryAdminOutboxMessage } from '../api/admin.client.js';

async function invalidateAdminQueries(): Promise<void> {
  await queryClient.invalidateQueries({ queryKey: [ADMIN_QUERY_ROOT] });
  await queryClient.refetchQueries({ queryKey: [ADMIN_QUERY_ROOT], type: 'active' });
}

export function useAdminMailMutations() {
  const retryMutation = useMutation({
    mutationFn: (messageId: string) => retryAdminOutboxMessage(messageId),
    onSuccess: invalidateAdminQueries,
  });

  return { retryMutation };
}
